const STORAGE_KEYS = {
  tasks: 'docket_tasks',
  projects: 'docket_projects',
  areas: 'docket_areas',
  tags: 'docket_tags',
};

function readKey(key) {
  try {
    const raw = localStorage.getItem(key);
    return raw ? JSON.parse(raw) : [];
  } catch {
    return [];
  }
}

function writeKey(key, data) {
  localStorage.setItem(key, JSON.stringify(data));
}

// ── Read ──────────────────────────────────────────────
export function loadAllLocal() {
  return {
    tasks: readKey(STORAGE_KEYS.tasks),
    projects: readKey(STORAGE_KEYS.projects),
    areas: readKey(STORAGE_KEYS.areas),
    tags: readKey(STORAGE_KEYS.tags),
  };
}

// ── Write (full replace) ──────────────────────────────
export function saveAllLocal({ tasks, projects, areas, tags }) {
  if (tasks !== undefined) writeKey(STORAGE_KEYS.tasks, tasks);
  if (projects !== undefined) writeKey(STORAGE_KEYS.projects, projects);
  if (areas !== undefined) writeKey(STORAGE_KEYS.areas, areas);
  if (tags !== undefined) writeKey(STORAGE_KEYS.tags, tags);
}

// ── Granular helpers (used by optimistic dispatch) ────
export function saveTasks(tasks) {
  writeKey(STORAGE_KEYS.tasks, tasks);
}

export function saveProjects(projects) {
  writeKey(STORAGE_KEYS.projects, projects);
}

export function saveAreas(areas) {
  writeKey(STORAGE_KEYS.areas, areas);
}

export function saveTags(tags) {
  writeKey(STORAGE_KEYS.tags, tags);
}

export function loadTasks() { return readKey(STORAGE_KEYS.tasks); }
export function loadProjects() { return readKey(STORAGE_KEYS.projects); }
export function loadAreas() { return readKey(STORAGE_KEYS.areas); }
export function loadTags() { return readKey(STORAGE_KEYS.tags); }

// ── Check if local data exists ────────────────────────
export function hasLocalData() {
  const d = loadAllLocal();
  return d.tasks.length > 0 || d.projects.length > 0;
}

// ── Anonymous-data marker ─────────────────────────────
// Set when data is created while signed out; the sign-in migration only
// pushes local data when this flag is present. Without it, every app launch
// (auth flips false→true during the session check) re-uploaded the cached
// server mirror, resurrecting tasks deleted or completed on other devices.
const ANON_FLAG_KEY = 'docket_anon_data';

export function markAnonData() {
  try { localStorage.setItem(ANON_FLAG_KEY, '1'); } catch {}
}

export function clearAnonDataFlag() {
  try { localStorage.removeItem(ANON_FLAG_KEY); } catch {}
}

export function hasAnonData() {
  try { return localStorage.getItem(ANON_FLAG_KEY) === '1'; } catch { return false; }
}

// ── Clear local data (after successful cloud sync) ────
export function clearLocalData() {
  Object.values(STORAGE_KEYS).forEach((k) => localStorage.removeItem(k));
}
